import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ExportAllModel from "../../models/export-all";

export default class ExportAllRepository extends BaseRepository {
  static modelClass = ExportAllModel;
  modelName = "export-all";
  async export(params, selectedDocuments) {
    const caseId = params.id;
    const body = selectedDocuments ? { document_ids: selectedDocuments } : {};

    return super.post(body, {
      urlPath: `case/${caseId}/export-all/`,
    });
  }
}
